import React, { Component } from 'react';

import HelpfulInfoChildPageBase from '../HelpfulInfoChildPageBase';

interface OwnProps {}
interface OwnState {}

class StudentVisaApply extends Component<OwnProps, OwnState> {
  render() {
    return <HelpfulInfoChildPageBase pageID={1264} />;
  }
}
export default StudentVisaApply;
